module.exports = __webpack_public_path__ + "img/05.f4b3295e.jpg";